module.exports = __webpack_public_path__ + "static/media/tshirts.9ee18934.jpeg";